<template>
  <div class="result-comp-common">
    <div class="result-area">
      <div class="title-row">
        <div class="result-title">{{ $t('receiveNtfc.saleCplt.title') }}</div>
      </div>
      <div class="image-area">
        <cplt-round-lottie />
      </div>
      <p class="result-text"><span class="name-text">{{ info.name }}</span><br>{{ $t('receiveNtfc.saleCplt.text') }}</p>
    </div>
    <div class="button-row">
      <mv-button type="rec-primary" text="common.confirm" @click="$emit('ok')" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import MvButton from '@/components/common/button/MvButton.vue';
import CpltRoundLottie from '@/components/common/lottie/CpltRoundLottie.vue';

export default defineComponent({
  name: 'UserInviteComp',
  emits: ['ok'],
  props: {
    info: {
      default: {
        id: 0,
        type: '',
        name: '',
      },
    },
  },
  components: {CpltRoundLottie, MvButton },
  setup() {
    return {};
  },
});
</script>

<style lang="scss" scoped>
.result-text {
  color: var(--typo-body);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}
.name-text {
  color: var(--typo-black);
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}
</style>
